export { fetchTrainerByName, fetchTrainerById } from "./api";
